﻿document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tolhuin-flavours]').forEach((section) => {
    const dialog = section.querySelector('[data-flavour-dialog]');
    if (!dialog) return;

    const setText = (selector, value) => {
      const element = dialog.querySelector(selector);
      if (element) element.textContent = value || '';
    };

    section.querySelectorAll('[data-flavour-card]').forEach((card) => {
      card.addEventListener('click', () => {
        setText('[data-dialog-name]', card.dataset.name);
        setText('[data-dialog-description]', card.dataset.description);
        setText('[data-dialog-ingredients]', card.dataset.ingredients);
        setText('[data-dialog-allergens]', card.dataset.allergens);
        dialog.querySelector('[data-dialog-ingredients-wrap]').hidden = !card.dataset.ingredients;
        dialog.querySelector('[data-dialog-allergens-wrap]').hidden = !card.dataset.allergens;
        const badges = dialog.querySelector('[data-dialog-badges]');
        badges.replaceChildren();
        const addBadge = (text, className, icon = '') => {
          if (!text) return;
          const badge = document.createElement('span');
          badge.className = `tol-flavour-card__badge ${className}`;
          badge.innerHTML = `${icon}${text}`;
          badges.appendChild(badge);
        };
        if (card.dataset.special === 'true') {
          addBadge(card.dataset.category || 'Special', 'tol-flavour-card__badge--special', '<span class="tol-flavour-card__sparkle" aria-hidden="true">&#10022;</span> ');
        }
        if (card.dataset.featureBadge) {
          const featureClass = `tol-flavour-card__badge--${card.dataset.featureBadgeKey || card.dataset.featureBadge.toLowerCase().replace(/\s+/g, '-')}`;
          const icon = card.dataset.featureBadgeKey === 'top-seller' ? '<span aria-hidden="true">&#128293;</span> ' : '';
          addBadge(card.dataset.featureBadge, `tol-flavour-card__badge--feature ${featureClass}`, icon);
        }
        const addLink = dialog.querySelector('[data-add-flavour-link]');
        const rootUrl = (section.dataset.rootUrl || '/').replace(/\/?$/, '/');
        addLink.href = `${rootUrl}pages/build-your-box?view=build-your-box&flavour=${encodeURIComponent(card.dataset.name)}`;

        const image = dialog.querySelector('[data-dialog-image]');
        const thumbs = dialog.querySelector('[data-dialog-thumbs]');
        image.style.background = getComputedStyle(card).getPropertyValue('--flavour-color');
        image.replaceChildren();
        thumbs.replaceChildren();
        const images = [card.dataset.image, card.dataset.image2, card.dataset.image3, card.dataset.image4].filter(Boolean);
        const showImage = (source) => {
          image.replaceChildren();
          const img = document.createElement('img');
          img.src = source;
          img.alt = card.dataset.name;
          image.appendChild(img);
        };
        if (images.length) {
          showImage(images[0]);
          images.forEach((source, index) => {
            const thumb = document.createElement('button');
            thumb.type = 'button';
            thumb.setAttribute('aria-label', `View image ${index + 1} of ${card.dataset.name}`);
            const thumbImage = document.createElement('img');
            thumbImage.src = source;
            thumbImage.alt = '';
            thumb.appendChild(thumbImage);
            thumb.addEventListener('click', () => showImage(source));
            thumbs.appendChild(thumb);
          });
          thumbs.hidden = images.length < 2;
        } else {
          const placeholder = document.createElement('span');
          placeholder.textContent = card.dataset.name.slice(0, 1);
          image.appendChild(placeholder);
          thumbs.hidden = true;
        }
        dialog.showModal();
      });
    });

    dialog.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });
});
